import { Component, Inject, OnInit, Optional } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-description-details',
  templateUrl: './description-details.component.html',
  styleUrls: ['./description-details.component.css']
})
export class DescriptionDetailsComponent implements OnInit {
  datas
  constructor(@Optional() @Inject(MAT_DIALOG_DATA) public data: any,public dialogRef: MatDialogRef<DescriptionDetailsComponent>) { 
    this.datas = data    
  }

  ngOnInit(): void {
  }
  cancelReason() {
    this.dialogRef.close();
  }
}
